import React from 'react';

function Hero() {
  return (
    <section className="bg-gradient-to-br from-blue-50 via-white to-purple-100 py-24 px-4 md:px-0">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Colonne gauche : texte */}
        <div className="flex-1 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4 leading-tight">
            Révélez le potentiel<br className="hidden md:block" />
            de vos <span className="text-purple-500">relations</span>
          </h1>
          <p className="text-lg text-blue-700 mb-8 max-w-lg">
            KORA est votre assistant personnel pour structurer, enrichir et valoriser vos relations professionnelles, tout en développant vos soft skills.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center md:justify-start">
            <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-600 transition transform hover:scale-105 hover:shadow-2xl">Créer mon compte</button>
            <button className="border-2 border-blue-500 text-blue-500 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-blue-50 transition bg-white transform hover:scale-105 hover:shadow-lg">Voir la démo</button>
          </div>
        </div>
        {/* Colonne droite : mockup image */}
        <div className="flex-1 flex justify-center">
          <div className="bg-white rounded-2xl shadow-xl p-2 flex items-center justify-center min-w-[260px] min-h-[400px]">
            <img
              src="/mockup-kora.png"
              alt="Mockup KORA"
              className="rounded-xl shadow-lg object-cover w-[220px] h-[420px] border-4 border-gray-100"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero; 